(function () {
	'use strict';
	$(document).ready(function () {
		let map;
		let markers = [];
		let data;

		const centerOfPoland = {
			lat: 52.131225,
			lng: 19.375568
		};

		filterCitySelect();
		filterTypesSelect();

		function initMap() {
			data = $('#data > .target');

			map = new google.maps.Map(document.getElementById("map"), {
				center: centerOfPoland,
				zoom: 6,
				disableDefaultUI: true,
				styles: stylesArray
			});
			data.each(function () {
				let marker = new google.maps.Marker({
					position: {
						lat: Number($(this).attr('data-lat')),
						lng: Number($(this).attr('data-long'))
					},
					map,
					placeId: $(this).attr('id'),
					animation: google.maps.Animation.DROP,
					icon: '/wp-content/themes/wp-bootstrap-gulp-master/dist/images/map-pin.svg'
				});

				marker.addListener("click", () => {
					$('#data').addClass('collapsed');
					if (!$(this).hasClass('active')){
						$('.target.active').removeClass('active').find('.info-details').slideUp();
						$(this).addClass('active').find('.info-details').slideDown({
							start: function () {
								$(this).css({
									display: "flex"
								})
							},
							done: function () {
								$('#data').animate({
									scrollTop: $('#' + marker.placeId).offset().top - $('#data').offset().top
								},2000)
							}
						});

						map.setCenter(marker.getPosition());
						map.setZoom(16);
					}
				});

				markers.push(marker);
			});

		}
		if (typeof google !== 'undefined') {
			initMap();
		}

		$('.info .arrow').on('click', function () {
			let target = $(this).closest('.target');
			if (target.hasClass('active')){
				target.removeClass('active').find('.info-details').slideUp();
			} else {
				$('.target.active').removeClass('active').find('.info-details').slideUp();
				target.addClass('active').find('.info-details').slideDown({
					start: function () {
						$(this).css({
							display: "flex"
						})
					}
				});

				for (var i = 0; i < markers.length; i++) {
					if(markers[i].placeId == target.attr('id')) {
						map.setCenter(markers[i].getPosition());
					}
				}
			}
		})

		$('#data .back-arrow').on('click', function () {
			$('.target.active').removeClass('active').find('.info-details').slideUp();
			$('#data').removeClass('collapsed');
			map.setCenter(centerOfPoland);
			map.setZoom(6);
		})


		$('#type').on('change', filterCitySelect)
		$('#city').on('change', filterTypesSelect)

		function filterTypesSelect(){
			let $this = $('#city');
			let selected = $this.find(':selected');
			let type = selected.attr('data-type');

			$('#type option').each(function () {
				if (type == null || type === '' || type.includes($(this).val())) {
					$(this).removeAttr('disabled');
				}
				else {
					$(this).attr('disabled', 'disabled');
				}
			})
		}

		function filterCitySelect() {
			let $this = $('#type');
			let selected = $this.find(':selected');
			let type = selected.val();

			$('#city option').each(function () {
				if (type == null || type === '' || $(this).attr('data-type')?.includes(type)) {
					$(this).removeAttr('disabled');
				}
				else {
					$(this).attr('disabled', 'disabled');
				}
			})
		}

		const stylesArray = [
			{
				"featureType": "administrative",
				"elementType": "geometry",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "poi",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "road",
				"elementType": "labels.icon",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "transit",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			}
		];
	});
}(jQuery));